import React, { Component, Fragment, useEffect } from "react";
import ReactDOM from "react-dom";

function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}


class ViewPixelogReply extends Component {

 	timeBefore = (date) => {
    	timeBefore(date);
  	}

	render(){

		const { reply, replyCnt, session_uid, session_nick, datakey, replyisLoading, session_profileUrl } = this.props;

	  	const ViewReplyStep = (
	      <ViewPixelogReplyStep
	        key={datakey}     
	        reply={reply} //
	        replyCnt={replyCnt} //
	        session_uid={session_uid}
	        // session_profileKey={session_profileKey}
            session_profileUrl={session_profileUrl}
	        session_nick={session_nick}
	        replyisLoading={replyisLoading}
	        datakey={datakey}
	      />
	    );

		//댓글 스크롤
		var scrollspy_class = '';

		if(session_uid == 'null'){
			scrollspy_class = 'scrollspy-nologin';
		}else{
			scrollspy_class = 'scrollspy';
		} 

	 	// const imgOnload = (imgkey) => {    	    
	  //   	window.pskl.website.createAnimatedPreviewforVIEW(imgkey, 1, event, false);
	  // 	}

		const actionReply = (method, id) => {
			action_reply(method, id);
		}	  	

		const btnAddStep = ( id ) => {
			const { session_uid, session_profileUrl, session_nick, datakey } = this.props;
			btnAdd_step( id, session_uid, session_profileUrl, session_nick, datakey );
		}

        // 신고 버튼
        const reportOnclick = (key) => {
            var winUid = window.__pageInfo.uid;
            action_report(key, winUid, '2');
        }

		// var filtered = $.grep(reply, function (el) {
		// 	//return el.imagekey;
		// 	console.log(el.imgkey);
		// 	console.log(typeof(el.imgkey));
		// });

		//댓글셋팅
		const replyList = reply.map(	
		(reply, index) => 
		  (     
		  <Fragment key={index}>
		  		{
		  			reply.step == 1 &&
		  			(
		  				<Fragment>
		  				{
		  					session_uid !== 'null' ?
		  					(
		  							session_uid == reply.uid ?
		  							(
		  								<Fragment>
										<div id={`media${reply.id}`} className="media align-items-center">
											<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
												<span className="card-follow-container d-inline-block align-middle position-relative">
												{													
													typeof reply.imgkey === 'string' ?
													(
                                                        <img
                                                            className="img-follow rounded-circle"
                                                            src={session_profileUrl}
                                                        />
													)
													:
													(
														<img
															className="img-follow-null rounded-circle" 
															src="/img/pixelog-profile.png"
														/>
													)
												}	
											    <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
											    </span>
											</a>
											<div className="ms-2 media-body">
											    <a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
											        <span className="card-follow-body d-inline-block font-weight-bold">
											        	<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
											        </span>
											    </a>
											    <span id={`reply${reply.id}`} className="ms-1">{reply.reply}</span>
											</div>
										</div>
										<div id={`media_bottom${reply.id}`} className="mb-3" style={{"marginLeft":"45px"}}>
											<span id={`reply_time${reply.id}`} className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
                                            <span className={'ms-2 fs-13 text-secondary cursor-pointer stepIcon'} id={`stepIcon${reply.id}`} onClick={ () => btnAddStep(reply.id)}>
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="ms-2 bi bi-chat-square-text cursor-pointer" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.5a2 2 0 0 1 1.6.8L8 14.333 9.9 11.8a2 2 0 0 1 1.6-.8H14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                                    <path fillRule="evenodd" d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                                                </svg> 답글쓰기
                                            </span>
											<span aria-haspopup="true" aria-expanded="false" data-bs-toggle="dropdown">
												<svg width="1em" height="1em" viewBox="0 0 16 16" className="ms-2 bi bi-three-dots position-relative dropdown-toggle cursor-pointer" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
											  		<path fillRule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
												</svg>												
											</span>
											<div className="ms-2 dropdown-menu text-center">
										  		<a className="dropdown-item cursor-pointer" onClick={ () => actionReply('edit', reply.id)}>수정</a>
										  		<a className="dropdown-item cursor-pointer" onClick={ () => actionReply('delete', reply.id)}>삭제</a>
											</div>
											<ViewPixelogReplyStep
												id={reply.id}
												reply={this.props.reply}
												replyCnt={this.props.replyCnt}
												session_uid={this.props.session_uid}
												session_profileUrl={this.props.session_profileUrl}
												session_nick={this.props.session_nick}
												datakey={this.props.datakey}
											/>

										</div>
										</Fragment>
		  							)
		  							:
		  							(
		  								<Fragment>		  									
										<div className="media align-items-center">
											<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
												<span className="card-follow-container d-inline-block align-middle position-relative">
												{
													typeof reply.imgkey === 'string' ?
													(
                                                        reply.type == 1 ?
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/outputs/txt2img/20${reply.imgkey_created_at.substring(2,4)}-${reply.imgkey_created_at.substring(5,7)}-${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
                                                        :
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/upload/${reply.imgkey_created_at.substring(2,4)}/${reply.imgkey_created_at.substring(5,7)}/${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
													)
													:
													(
														<img
															className="img-follow-null rounded-circle" 
															src="/img/pixelog-profile.png"
														/>
													)
												}	
												<div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
												</span>
											</a>
											<div className="ms-2 media-body">
												<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
												    <span className="card-follow-body d-inline-block font-weight-bold">
												    	<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
												    </span>
												</a>
												<span id={`reply${reply.id}`} className="ms-1">{reply.reply}</span>
											</div>
										</div>
										<div id={`media_bottom${reply.id}`} className="mb-3" style={{"marginLeft":"45px"}}>
											<span className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
                                            <span className={'ms-2 fs-13 text-secondary cursor-pointer'} onClick={() => reportOnclick(reply.id)}>신고</span>
                                            <span className={'ms-2 fs-13 text-secondary cursor-pointer stepIcon'} id={`stepIcon${reply.id}`} onClick={ () => btnAddStep(reply.id)}>
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="ms-2 bi bi-chat-square-text cursor-pointer" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.5a2 2 0 0 1 1.6.8L8 14.333 9.9 11.8a2 2 0 0 1 1.6-.8H14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                                    <path fillRule="evenodd" d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                                                </svg> 답글쓰기
                                            </span>
											<ViewPixelogReplyStep
												id={reply.id}
												reply={this.props.reply}
												replyCnt={this.props.replyCnt}
												session_uid={this.props.session_uid}
                                                session_profileUrl={this.props.session_profileUrl}
												session_nick={this.props.session_nick}
												datakey={this.props.datakey}
											/>											
										</div>
		  								</Fragment>
		  							)
		  					)
		  					:
		  					(
		  						<Fragment>
								<div className="media align-items-center">
									<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
										<span className="card-follow-container d-inline-block align-middle position-relative">
											{
												typeof reply.imgkey === 'string' ?
												(
                                                    reply.type == 1 ?
                                                    (
                                                        <img
                                                            className="img-follow rounded-circle"
                                                            src={`/outputs/txt2img/20${reply.imgkey_created_at.substring(2,4)}-${reply.imgkey_created_at.substring(5,7)}-${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                        />
                                                    )
                                                    :
                                                    (
                                                        <img
                                                            className="img-follow rounded-circle"
                                                            src={`/upload/${reply.imgkey_created_at.substring(2,4)}/${reply.imgkey_created_at.substring(5,7)}/${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                        />
                                                    )
												)
												:
												(
													<img
														className="img-follow-null rounded-circle"
														src="/img/pixelog-profile.png"
													/>
												)
											}										    
											<div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
									   	</span>
									</a>
									<div className="ms-2 media-body">
									   	<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
									       	<span className="card-follow-body d-inline-block font-weight-bold">
									        	<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
									       	</span>
									    </a>
									   	<span className="ms-1">{reply.reply}</span>
									</div>
								</div>
								<div id={`media_bottom${reply.id}`} className="mb-3" style={{"marginLeft":"45px"}}>
									<span className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
                                    <span className={'ms-2 fs-13 text-secondary cursor-pointer'} onClick={() => reportOnclick(reply.id)}>신고</span>
									<ViewPixelogReplyStep
										id={reply.id}
										reply={this.props.reply}
										replyCnt={this.props.replyCnt}
										session_uid={this.props.session_uid}
                                        session_profileUrl={this.props.session_profileUrl}
										session_nick={this.props.session_nick}
										datakey={this.props.datakey}
									/>									
								</div>
								</Fragment>
		  					)
		  				}		  					
		  				</Fragment>
		  			)
		  		}
		  </Fragment>
		  )
		);


		return (
				<Fragment>
				<ScrollToTopOnMount />
				<div id={`reply_area`} className={`mt-3 ${scrollspy_class}`} data-spy="scroll" data-target="#navbar" data-offset="0">
				{
					replyCnt == 0 ?
					(           
					<div id="empty_area" className="w-100 alert alert-white text-center" role="alert">
						<h6>댓글이 없습니다.</h6>
					</div>
					)
					:
					(
					<Fragment>
						{replyList}
					</Fragment>
					)
				}				            
				{
				  	replyisLoading == true &&
				  	(
				    <div className="spin-container">
						<div id="loadcontainer-tags0" className="spinner-border pb-3" style={{"width":"3rem", "height":"3rem"}} role="status"></div>
				    </div>
				  	)
				}
				</div>
				</Fragment>
		);//return
	}//render
}

class ViewPixelogReplyStep extends Component {

 	timeBefore = (date) => {
    	timeBefore(date);
  	}

	render(){
		
		const { id, reply, session_uid } = this.props;

	 	// const imgOnload = (imgkey) => {    	    
	  //   	window.pskl.website.createAnimatedPreviewforVIEW(imgkey, 1, event, false);
	  // 	}

		const actionReply = (method, id) => {
			action_reply(method, id);
		}

        // 신고 버튼
        const reportOnclick = (key) => {
            var winUid = window.__pageInfo.uid;
            action_report(key, winUid, '2');
        }

		const replyList = reply.map(			
		(reply, index) => 
		  (     
		  <Fragment key={index}>
		  		{
		  			reply.step == 2 && reply.rid == id &&
		  			(
		  				<Fragment>
		  				{
		  					session_uid !== 'null' ?
		  					(
		  							session_uid == reply.uid ?
		  							(
		  								<Fragment>
										<div id={`media${reply.id}`} className="media align-items-center mt-3">
											<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
										  	<span className="card-follow-container d-inline-block align-middle position-relative">
												{
													//reply.imgkey !== null ?
													typeof reply.imgkey === 'string' ?
                                                    (

                                                        reply.type == 1 ?
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/outputs/txt2img/20${reply.imgkey_created_at.substring(2,4)}-${reply.imgkey_created_at.substring(5,7)}-${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
                                                        :
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/upload/${reply.imgkey_created_at.substring(2,4)}/${reply.imgkey_created_at.substring(5,7)}/${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
													)
													:
													(
														<img
															className="img-follow-null rounded-circle" 
															src="/img/pixelog-profile.png"
														/>
													)
												}	
											    <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
										    </span>
										  	</a>
										  	<div className="ms-2 media-body">
										    <a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
										        <span className="card-follow-body d-inline-block font-weight-bold">
										        	<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
										        </span>
										    </a>
										    <span id={`reply${reply.id}`} className="ms-1" >{reply.reply}</span>
											</div>
										</div>
										<div id={`media_bottom${reply.id}`} className="mb-3" style={{"marginLeft":"45px"}}>
											<span className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
											<span aria-haspopup="true" aria-expanded="false" data-bs-toggle="dropdown">
												<svg width="1em" height="1em" viewBox="0 0 16 16" className="ms-2 bi bi-three-dots position-relative dropdown-toggle cursor-pointer" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
											  		<path fillRule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
												</svg>
											</span>
											<div className="dropdown-menu text-center">
											  	<a className="dropdown-item cursor-pointer" onClick={ () => actionReply('edit', reply.id) }>수정</a>
											  	<a className="dropdown-item cursor-pointer" onClick={ () => actionReply('delete', reply.id) }>삭제</a>										  		
											</div>
										</div>
										</Fragment>          
		  							)
		  							:
		  							(
		  								<Fragment>
										<div id={`media${reply.id}`} className="media align-items-center mt-3">
											<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
											<span className="card-follow-container d-inline-block align-middle position-relative">
												{
													typeof reply.imgkey === 'string' ?
													(

                                                        reply.type == 1 ?
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/outputs/txt2img/20${reply.imgkey_created_at.substring(2,4)}-${reply.imgkey_created_at.substring(5,7)}-${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
                                                        :
                                                        (
                                                            <img
                                                                className="img-follow rounded-circle"
                                                                src={`/upload/${reply.imgkey_created_at.substring(2,4)}/${reply.imgkey_created_at.substring(5,7)}/${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                            />
                                                        )
													)
													:
													(
														<img
															className="img-follow-null rounded-circle" 
															src="/img/pixelog-profile.png"
														/>
													)
												}	
										    	<div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
										    </span>
											</a>
											<div className="ms-2 media-body">
											    <a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
											        <span className="card-follow-body d-inline-block font-weight-bold">
											        	<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
											        </span>
											    </a>
											    <span id={`reply${reply.id}`} className="ms-1">{reply.reply}</span>
											</div>
										</div>
										<div className="mb-3" style={{"marginLeft":"45px"}}>
											<span className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
                                            <span className={'ms-2 fs-13 text-secondary cursor-pointer'} onClick={() => reportOnclick(reply.id)}>신고</span>
                                        </div>
		  								</Fragment>
		  							)		  						
		  					)
		  					:
		  					(	
		  						<Fragment>
								<div className="media align-items-center mt-3">
									<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
									<span className="card-follow-container d-inline-block align-middle position-relative">
										{
											typeof reply.imgkey === 'string' ?											
											(

                                                reply.type == 1 ?
                                                (
                                                    <img
                                                        className="img-follow rounded-circle"
                                                        src={`/outputs/txt2img/20${reply.imgkey_created_at.substring(2,4)}-${reply.imgkey_created_at.substring(5,7)}-${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                    />
                                                )
                                                :
                                                (
                                                    <img
                                                        className="img-follow rounded-circle"
                                                        src={`/upload/${reply.imgkey_created_at.substring(2,4)}/${reply.imgkey_created_at.substring(5,7)}/${reply.imgkey_created_at.substring(8,10)}/${reply.imgkey}.png`}
                                                    />
                                                )
											)
											:
											(
												<img
													className="img-follow-null rounded-circle" 
													src="/img/pixelog-profile.png"
												/>
											)
										}
										<div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
									</span>
									</a>
									<div className="ms-2 media-body">
										<a className="text-decoration-none card-preview-link" href={`/user/${reply.uid}`}>
										<span className="card-follow-body d-inline-block font-weight-bold">
											<span className="text-truncate text-dark mobile-title">{reply.nick}</span>
										</span>
										</a>
										<span className="ms-1">{reply.reply}</span>
									</div>
								</div>
								<div className="mb-3" style={{"marginLeft":"45px"}}>
									<span className="text-secondary" style={{"fontSize":"10px"}}>{timeBefore(reply.updated_at)}</span>
                                    <span className={'ms-2 fs-13 text-secondary cursor-pointer'} onClick={() => reportOnclick(reply.id)}>신고</span>
								</div>
								</Fragment>
		  					)
		  				}
		  				</Fragment>
		  			)
		  		}
		  </Fragment>
		  )
		);


		return(
			<div>{replyList}</div>
		);
	}
}

export default ViewPixelogReply;




